import type { InteractionType } from '~/model/InteractionType';
import type { ProjectType } from '~/model/ProjectType';
import { PictureInsert } from '~/components/commons/PictureInsert/PictureInsert';
import { VideoInsert } from '~/components/commons/VideoInsert/VideoInsert';

export const InteractionMedia = ({
  interaction,
  project,
}: {
  interaction: InteractionType;
  project: ProjectType;
}) => {
  const interactionMedia = interaction.media;
  const interactionVideo = interaction.video_url;
  const projectMedia = project.media;
  const projectVideo = project.video_url;

  const interactionIllustration = interactionVideo
    ? (
        <VideoInsert url={interactionVideo} title={interaction.title} />
      )
    : (
        interactionMedia && <PictureInsert url={interactionMedia.content_url} />
      );

  const projectIllustration = projectVideo
    ? (
        <VideoInsert url={projectVideo} title={interaction.title} />
      )
    : (
        projectMedia && <PictureInsert url={projectMedia.content_url} />
      );

  return (
    <header>
      {interactionIllustration || projectIllustration || null}
    </header>
  );
};
